import React from "react";
import {
  Box,
  Chip,
  Divider,
  FormControl,
  IconButton,
  MenuItem,
  Select,
  Tooltip,
  Typography,
} from "@mui/material";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import CalendarViewWeekIcon from "@mui/icons-material/CalendarViewWeek";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { Sprint, ViewMode } from "./types";
import moment from "moment";

interface SprintHeaderProps {
  sprint: Sprint;
  totalTasks: number;
  viewMode: ViewMode;
  setViewMode: (mode: ViewMode) => void;
  zoom: number;
  setZoom: React.Dispatch<React.SetStateAction<number>>;
  anchor: Date;
}

export const SprintHeader: React.FC<SprintHeaderProps> = ({
  sprint,
  totalTasks,
  viewMode,
  setViewMode,
  zoom,
  setZoom,
  anchor,
}) => {
  const formatSprintDate = (dateStr: string) => {
    return moment(dateStr).format("DD MMM, YYYY");
  };

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", px: 2, py: 1.5 }}>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          {sprint.name}
        </Typography>
        <Box sx={{ ml: 1.5, color: "#6B7280", fontSize: 14 }}>
          {sprint.project.code}
        </Box>
        <Box sx={{ ml: 2 }}>
          <Chip
            size="small"
            label={sprint.status}
            color={sprint.status === "ACTIVE" ? "success" : "default"}
            sx={{ fontWeight: 600 }}
          />
        </Box>
        {/* <Box sx={{ ml: 2, color: "#6B7280", fontSize: 14 }}>
          {totalTasks} tasks • {sprint.doneBugCount} completed
        </Box> */}
        <Box sx={{ flex: 1 }} />

        {/* <FormControl size="small" sx={{ minWidth: 160, mr: 2 }}>
          <Select
            value={viewMode}
            onChange={(e) => setViewMode(e.target.value as ViewMode)}
            displayEmpty
            sx={{
              "& .MuiSelect-select": {
                display: "flex",
                alignItems: "center",
                gap: 1,
                py: 0.75,
              },
            }}
          >
            <MenuItem value="sprint">
              <CalendarViewWeekIcon sx={{ fontSize: 18 }} />
              Sprint Date View
            </MenuItem>
            <MenuItem value="month">
              <CalendarMonthIcon sx={{ fontSize: 18 }} />
              Month View
            </MenuItem>
          </Select>
        </FormControl> */}

        <Tooltip title="Zoom In">
          <span>
            <IconButton
              onClick={() => setZoom((z) => Math.min(1.4, z + 0.1))}
              size="small"
            >
              <ZoomInIcon />
            </IconButton>
          </span>
        </Tooltip>
        <Tooltip title="Zoom Out">
          <span>
            <IconButton
              onClick={() => setZoom((z) => Math.max(0.8, z - 0.1))}
              size="small"
            >
              <ZoomOutIcon />
            </IconButton>
          </span>
        </Tooltip>
      </Box>

      <Divider />

      {(sprint.startDate || sprint.endDate) && (
        <Box
          sx={{
            px: 2,
            py: 1,
            bgcolor: "#F9FAFB",
            borderBottom: "1px solid #E5E7EB",
          }}
        >
          <Typography
            variant="caption"
            sx={{ color: "#6B7280", fontWeight: 500 }}
          >
            {sprint.startDate && sprint.endDate ? (
              <>
                Sprint Duration: {formatSprintDate(sprint.startDate)} →{" "}
                {formatSprintDate(sprint.endDate)}
                <Chip
                  label={`${
                    Math.ceil(
                      (new Date(sprint.endDate).getTime() -
                        new Date(sprint.startDate).getTime()) /
                        (1000 * 60 * 60 * 24)
                    ) + 1
                  } days`}
                  size="small"
                  sx={{ ml: 1, height: 18, fontSize: 10 }}
                />
              </>
            ) : sprint.startDate ? (
              `Started: ${formatSprintDate(sprint.startDate)}`
            ) : (
              `Ends: ${formatSprintDate(sprint.endDate)}`
            )}
          </Typography>
        </Box>
      )}
    </>
  );
};
